/**
 * @function AES对字符串加密
 * @text string 加密字符串
 * @return string 十六进制字符串
 * @author 成传红 2020-07-30
 */
import CryptoJS from 'crypto-js';
function EncryptString(text) {
  var keyHex = CryptoJS.enc.Utf8.parse("ZDMedical.com.cn");
  var encrypted = CryptoJS.AES.encrypt(text, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString();
}

/**
 * @function AES对字符串解密
 * @text string 解密字符串
 * @return string 字符串
 * @author 成传红 2020-07-30
 */
function DecryptString(text) {
  var keyHex = CryptoJS.enc.Utf8.parse("ZDMedical.com.cn");
  var decrypted = CryptoJS.AES.decrypt(
    {
      ciphertext: CryptoJS.enc.Hex.parse(text),
    },
    keyHex,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
}

export {DecryptString,EncryptString}



// WEBPACK FOOTER //
// ./static/js/xintong/AESUtils.js